import { ContactFormWrapper } from "@/app/parts/global/ContactFormWrapper";
import React from "react";

interface ContactFormSectionProps {
    title?: string;
    body?: 'body' | 'body.2';
    background?: string;
}

export const ContactFormSection = (_props: ContactFormSectionProps): React.FunctionComponentElement<ContactFormSectionProps> =>
    <ContactFormWrapper title={_props.title} body={_props.body} background={_props.background} />;
